module.exports = __webpack_public_path__ + "img/BNB-icon.7133f96d.svg";